"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiquidEngine = void 0;

var _liquidjs = require("liquidjs");

var _qrcodeGenerator = _interopRequireDefault(require("qrcode-generator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const engine = new _liquidjs.Liquid();
engine.registerFilter('money', number => new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR'
}).format(number / 100));
engine.registerFilter('qr_code', url => {
  const qr = (0, _qrcodeGenerator.default)(0, 'M');
  qr.addData(url);
  qr.make();
  return qr.createDataURL();
});
/**
 * Delivery Boostings Liquid Flavour Engine with added Filter support
 * Based on LiquidJS
 * @type {Liquid}
 */

const LiquidEngine = engine;
exports.LiquidEngine = LiquidEngine;